import { Store } from "lucide-react";

// Deterministic pastel per channel name so the same channel always looks the same.
const COLORS = [
  "bg-blue-100 text-blue-700",
  "bg-emerald-100 text-emerald-700",
  "bg-amber-100 text-amber-700",
  "bg-violet-100 text-violet-700",
  "bg-rose-100 text-rose-700",
  "bg-cyan-100 text-cyan-700",
  "bg-indigo-100 text-indigo-700",
];
const colorFor = (s) => {
  let h = 0;
  for (const c of String(s)) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return COLORS[h % COLORS.length];
};

/**
 * Channel "logo" chip: a real image when the channel has a `logoUrl`, otherwise
 * a deterministic initials avatar. Renders nothing when there's no channel.
 * Sizes: "sm" (lists) | "lg" (detail headers).
 */
export function ChannelBadge({ name, logoUrl, size = "sm", muted = false }) {
  if (!name) {
    return muted ? <span className="text-sm text-slate-400">Direct</span> : null;
  }
  const initials = String(name).trim().slice(0, 2).toUpperCase();
  const dim = size === "lg" ? "h-7 w-7 text-xs" : "h-5 w-5 text-[10px]";
  return (
    <span className="inline-flex min-w-0 items-center gap-1.5" title={name}>
      {logoUrl ? (
        <img src={logoUrl} alt="" className={`${dim} shrink-0 rounded border bg-white object-contain p-0.5`} />
      ) : (
        <span className={`inline-flex ${dim} shrink-0 items-center justify-center rounded-full font-bold ${colorFor(name)}`}>
          {initials || <Store className="h-3 w-3" />}
        </span>
      )}
      <span className="truncate text-sm text-slate-700">{name}</span>
    </span>
  );
}

export default ChannelBadge;
